

export const WS_TOKEN = 'DRT';
export const COOKIE_FOCUS_INUSE = 'FOCUSINUSE';